var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoftwareUpdates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100.54 98",
    style: {
      enableBackground: "new 0 0 100.54 98"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E90029;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.38,55.36c-2.13,0-3.85-1.73-3.85-3.85V3.95c0-2.13,1.72-3.85,3.85-3.85c2.13,0,3.85,1.73,3.85,3.85 V51.5C53.23,53.63,51.51,55.36,49.38,55.36L49.38,55.36z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "27.49,45.08 49.38,83.03 71.26,45.08 27.49,45.08  "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96.4,75.9c-2.13,0-3.85,1.73-3.85,3.85v10.44H7.96V79.75c0-2.13-1.73-3.85-3.85-3.85 c-2.13,0-3.85,1.73-3.85,3.85v14.3c0,0.94,0.35,1.79,0.91,2.46c0.71,0.84,1.75,1.39,2.94,1.39h92.3c1,0,1.9-0.39,2.58-1.01 c0.05-0.04,0.1-0.07,0.14-0.12c0.01-0.01,0.02-0.02,0.03-0.03c0.68-0.69,1.1-1.64,1.1-2.69v-14.3 C100.25,77.62,98.53,75.9,96.4,75.9z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftwareUpdates);
export default __webpack_public_path__ + "static/media/software-updates.77dbabebbbf02f59709433ca1fe8c005.svg";
export { ForwardRef as ReactComponent };